<template>
    <div>
        <CurrentMailings v-if="!mailingStore.inSettings" />
        <MailingSettings v-if="mailingStore.inSettings" />
    </div>
</template>

<script>
import CurrentMailings from './CurrentMailings/CurrentMailings.vue';
import MailingSettings from './MailingSettings/MailingSettings.vue';
import { useMailingStore } from "@/stores/MailingStore";

export default {
    name: "Mailing",
    components: {
        CurrentMailings,
        MailingSettings
    },
    setup() {
        const mailingStore = useMailingStore();
        return {
            mailingStore
        }
    },
}
</script>

<style>
.mailing_panel {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 36px;
    margin-top: 45px;
}

.mailing_header {
    display: flex;
    justify-content: space-between;
}

@media (max-width: 600px) {
    .mailing_header {
        flex-direction: column;
        gap: 15px;
    }

    .mailing_preview_title {
        word-break: break-all;
    }

    .tabs_wrapper:last-child {
        gap: 20px;
    }
}

.mailing_title {
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
}

.mailing_text_color__darkBlue {
    color: rgb(26, 55, 81);
}

.mailing_text_color__white {
    color: #FFF;
}
.mailing_text_color__blue {
    color: rgb(23, 74, 139);
}

.mailing_title_position {
    background-color: #FFF;
    position: absolute;
    top: -22px;
    left: 30px;
    padding: 6px 10px 6px 10px;
}

.mailing_button {
    display: flex;
    justify-content: center;
    padding: 17px 40px;
    background: rgb(23, 74, 139);
    color: rgb(255, 255, 255);
    font-size: 17px;
    font-weight: 500;
    line-height: 21px;
    border: none;
    cursor: pointer;
    box-shadow: 4px 4px #9ABCD6;
    transition: color 0.3s ease-out, background-color 0.3s ease-out;
}

.mailing_button:hover {
    color: rgb(23, 74, 139);
    box-shadow: 2px 2px #9ABCD6;
    background-color: #A0C084;
}

.mailing_tableWrapper {
    display: flex;
    width: 100%;
    overflow-x: scroll;
}
.mailing_table {
    display: grid;
    grid-template-columns: 240px 3fr 3fr 140px;
    flex-grow: 1;
}

.mailing_column_header {
    display: flex;
    width: 100%;
    padding: 10px;
    align-items: center;
    justify-content: flex-start;
    color: rgb(26, 55, 81);
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    border-bottom: 4px solid #174A8B;
    box-sizing: border-box;
}

.mailing_column {
    display: flex;
    overflow-x: hidden;
    text-overflow: ellipsis;
    gap: 3px;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    padding: 22px 10px;
    border-bottom: 1px dashed rgb(161, 161, 161);
    box-sizing: border-box;
}

.mailing_column_title {
    color: rgb(26, 55, 81);
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
}

.mailing_column_text {
    color: rgb(26, 55, 81);
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
}

.mailing_picker {
    display: grid;
    grid-template-columns: 1fr 7fr;
    gap: 22px;
}

.mailing_picker_days {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    width: 1300px;
}

.mailing_day_wrapper {
    display: flex;
    flex-direction: column;
}

.mailing_period_text_title {
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
}

.cursor_pointer {
    cursor: pointer;
}

.mailing_period_text {
    font-size: 18px;
    font-weight: 700;
    line-height: 23px;
}

.mailing_buttonWrapper {
    display: flex;
    width: 100%;
    justify-content: flex-end;
}

/* Стили input */

.mailing_inputs_wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px;
    width: fit-content;
    flex-grow: 1;
}

.mailing_inputs_container {
    display: flex;
    align-items: center;
    width: 64px;
    height: 34px;
    margin-bottom: 10px;
}

.mailing_day_unselected {
    width: 74px;
    height: 34px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.mailing_day_selected {
    color: #FFF;
    background: rgb(23, 74, 139);
}

.mailing_controls_wrapper {
    display: flex;
    flex-direction: column;
    gap: 74px;
    width: 260px;
}

.mailing_switcher_wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 10px;
}

.mailing_input_time {
    text-align: center;
    width: 42px;
    height: 34px;
    background-color: #174A8B;
    border: none;

    margin: 0;
}

.mailing_input_time::placeholder {
    text-align: center;
    color: #FFF;
}

.mailing_period_wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 690px;
    gap: 30px;
    height: fit-content;
    position: relative;
}

.mailing_input_wrapper {
    display: flex;
    position: relative;
    margin-top: 10px;
    height: 100%;
    width: 100%;
}

.mailing_h_64 {
    height: 64px;
}

.mailing_removeEmail_button {
    border: none;
    background: none;
    cursor: pointer;
}

.mailing_email_wrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    gap: 10px;
    border-left: solid 1px #ADADAD;
    border-right: solid 1px #ADADAD;
    border-bottom: solid 1px #ADADAD;
    padding: 5px;
    box-sizing: border-box;
}

.mailing_email_container {
    display: flex;
    color: #FFF;
    padding: 8px 10px;
    gap: 10px;
    width: fit-content;
    border-radius: 5px;
    background: rgb(0, 158, 213);
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
}

.flex_col {
    flex-direction: column;
}

.mailing_input_gray {
    display: flex;
    width: 100%;
    border: solid 1px #ADADAD;
    font-size: 15px;
    color: #174A8B;
    line-height: 22px;
    padding: 5px 5px 5px 5px;
    height: auto;
    flex-grow: 2;
    flex-basis: 712px;
    min-height: 55px;
}

.mailing_inputEmails_gray {
    display: flex;
    width: 100%;
    font-size: 15px;
    color: #174A8B;
    line-height: 22px;
    border: none;
    outline: none;
    padding: 5px 5px 5px 5px;
    height: auto;
    min-height: 67px;
    border-left: solid 1px #ADADAD;
    border-right: solid 1px #ADADAD;
    border-top: solid 1px #ADADAD;
    box-sizing: border-box;
}


/* Стили switch */

.mailing_switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 16px;
}

.mailing_switch_large {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 27px;
}

.mailing_switch input {
  display: none;
}

.mailing_switch_large input {
    display: none;
}

.mailing_slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #1A3751;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.mailing_slider_large {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #1A3751;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.mailing_slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 2px;
  background-color: #FFF;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.mailing_slider_large:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 5px;
    background-color: #FFF;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .mailing_slider {
  background-color: #174A8B;
}

input:checked + .mailing_slider_large {
  background-color: #174A8B;
}

input:focus + .mailing_slider {
  box-shadow: 0 0 1px #174A8B;
}

input:focus + .mailing_slider_large {
  box-shadow: 0 0 1px #174A8B;
}

input:checked + .mailing_slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

input:checked + .mailing_slider_large:before {
  -webkit-transform: translateX(28px);
  -ms-transform: translateX(28px);
  transform: translateX(28px);
}

.mailing_slider.mailing_round {
  border-radius: 12px;
}

.mailing_slider_large.mailing_round {
  border-radius: 16px;
}

.mailing_slider.mailing_round:before {
  border-radius: 50%;
}

.mailing_slider_large.mailing_round:before {
  border-radius: 50%;
}

.mailing_edits_button {
    display: flex;
    padding: 0;
    width: 24px;
    height: 24px;
    border: none;
    background: none;
    cursor: pointer;
}

.mailing_actions {
    display: flex;
    width: 100%;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
}

.mailing_panelControl_wrapper {
    display: flex;
    width: 100%;
    gap: 30px;
}

@media (max-width: 1500px) {
    .mailing_panelControl_wrapper {
        flex-direction: column;
    }
    .mailing_body {
        flex-direction: column;
        gap: 25px;
    }

    .mailing_inputs_wrapper {
        width: 100%;
    }

    .mailing_controls_wrapper {
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
        gap: 30px;
    }

    div.mailing_preview {
        width: 100%;
        min-height: 350px;
        height: auto;
        flex-shrink: 1;
        margin-right: 20px;
    }
}

.mailing_body {
    display: flex;
    width: 100%;
    gap: 50px;
}

.mailing_settings_wrapper {
    display: flex;
    flex-direction: column;
    gap: 35px;
}

.mailing_settings_container {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.mailing_button_remove {
    display: flex;
    gap: 5px;
    align-items: center;
    justify-self: flex-end;
    align-self: flex-end;
    cursor: pointer;
    text-decoration: underline;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: rgb(35, 123, 237);
    border: none;
    background-color: transparent;
    transition: color 0.3s ease-out;
}

.mailing_button_remove:hover {
    color: rgb(237, 35, 35);
}

.mailing_button_remove > svg > path {
    fill: #237BED;
    transition: fill 0.3s ease-out;
}

.mailing_button_remove:hover > svg > path {
    fill: rgb(237, 35, 35);
}

/* Стили модалок */

.modal_buttons {
    display: flex;
    justify-content: flex-end;

    margin-top: 50px;
}

.button_yes {
    margin-right: 34px;
}

@media (max-width: 768px) {
    .modal_buttons {
        display: flex;
        justify-content: center;
        margin-top: 50px;
    }
}

@media (max-width: 800px) {
    .mailing_picker_days {
        width: fit-content;
    }
}

.modal_select_from_contacts .title {
    text-align: center;
    width: 100%;
}
</style>
